import { render } from "./tenChallenge.vue?vue&type=template&id=3b2d433a&scoped=true"
import script from "./tenChallenge.vue?vue&type=script&lang=js"
export * from "./tenChallenge.vue?vue&type=script&lang=js"

import "./tenChallenge.vue?vue&type=style&index=0&id=3b2d433a&lang=less&scoped=true"

import exportComponent from "C:\\Users\\Administrator.DESKTOP-7G84OHA\\Desktop\\dduh-active-webh5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2d433a"]])

export default __exports__